import { BroadcastMessageType, CheckIfTheSessionIsTheSame, DropAllSessions } from './types';

export const checkIfTheSessionIsTheSame: CheckIfTheSessionIsTheSame = portalAccessToken => ({
  type: BroadcastMessageType.CheckIfTheSessionIsTheSame,
  payload: portalAccessToken,
});

export const dropAllSessions: DropAllSessions = dueToInactivity => ({
  type: BroadcastMessageType.DropAllSessions,
  payload: dueToInactivity,
});
